<template>
  <div class="credentials">
    <Header :title="title" :right-content="rightContent" />
    <div id="content">
      <div class="layout">
        <div class="credItem">
          <span>手持身份证</span>
          <p>您的信息平台将会进行加密处理，并会严格保密。</p>
        </div>
        <div class="card">
          <img v-if="isPrototype" src="@/assets/images/personalInfo/photo.png">
          <img v-if="isCredentials" preview="0" :src="photo">
          <input ref="inputMultiple" class="inputPhoto" type="file" accept="image/*" @change="multipleChange">
        </div>
        <div class="credItem">
          <p>拍摄提示</p>
          <p>1. 身份证的信息需要能清晰显示</p>
          <p>2. 人物五官需清晰、免冠</p>
          <p>3. 若不满意，可点击照片重新拍摄</p>
        </div>
        <div class="credItem"><a class="submit" :class="photo?'suc':''" @click="submit">下一步</a></div>
      </div>
    </div>
    <!--重复提交-->
    <RepeatPop v-if="isRepeatPop" />
  </div>
</template>

<script>
require('@/assets/css/credentials.css')
import Header from '@/view/module/Header.vue'
import RepeatPop from '@/view/module/RepeatPop.vue'
import api from '@/plugins/api'
export default {
  name: 'Credentials',
  components: { Header, RepeatPop },
  data() {
    return {
      title: '手持证件照',
      isPrototype: true,
      isCredentials: false,
      photo: '',
      photoFile: '',
      isRepeatPop: false,
      rightContent: 'isNo',
      isPreviewPop: false,
      faceType: this.$route.query.faceType || ''
    }
  },
  mounted() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    toggleFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.toggle('mainFixed')
    },
    multipleChange() {
      let url
      const inputMultiple = this.$refs.inputMultiple
      if (inputMultiple.files) {
        for (const file of inputMultiple.files) {
          url = URL.createObjectURL(file)
          this.checkPic(file)
          this.compressImg(file)
          this.photo = url
          this.isPrototype = false
          this.isCredentials = true
        }
      }
      // this.$previewRefresh();
    },
    compressImg(file) {
      if (file.size / 1024 > 1025) { // 大于1M，进行压缩上传
        this.photoCompress(file, { quality: 0.2 }, file.name)
      } else {
        this.photoFile = file
      }
    },
    photoCompress(file, w, name) {
      const ready = new FileReader()
      /* 开始读取指定的Blob对象或File对象中的内容. 当读取操作完成时,readyState属性的值会成为DONE,如果设置了onloadend事件处理程序,则调用之.同时,result属性中将包含一个data: URL格式的字符串以表示所读取文件的内容.*/
      ready.readAsDataURL(file)
      const _this = this
      ready.onload = function(e) {
        const path = e.target.result
        _this.canvasDataURL(path, w, name)
      }
    },
    canvasDataURL(path, obj, name) {
      const _this = this
      const img = new Image()
      img.src = path
      img.onload = function() {
        const that = this
        // 默认按比例压缩
        let w = that.width
        let h = that.height
        const scale = w / h
        w = obj.width || w
        h = obj.height || (w / scale)
        let quality = 0.7 // 默认图片质量为0.7
        // 生成canvas
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        // 创建属性节点
        const anw = document.createAttribute('width')
        anw.nodeValue = w
        const anh = document.createAttribute('height')
        anh.nodeValue = h
        canvas.setAttributeNode(anw)
        canvas.setAttributeNode(anh)
        ctx.drawImage(that, 0, 0, w, h)
        // 图像质量
        if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
          quality = obj.quality
        }
        // quality值越小，所绘制出的图像越模糊
        const base64 = canvas.toDataURL('image/jpeg', quality)
        // 回调函数返回base64的值
        _this.photoFile = _this.dataURLtoFile(base64, name)
      }
    },
    // base64转换为file
    dataURLtoFile(base64, filename) { // 将base64转换为文件
      var arr = base64.split(','); var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1]); var n = bstr.length; var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    checkPic(file) {
      const extName = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
      const AllUpExt = '.bmp|.gif|.jpg|.jpeg|.png|.tif|.tiff|'
      if (AllUpExt.indexOf(extName + '|') == '-1') {
        return false
      } else if (file.size > 5242880) {
        return false
      }
      return true
    },
    submit() {
      const fileFormData = new FormData()
      fileFormData.append(`other2File`, this.photoFile)
      fileFormData.append(`faceType`, this.faceType)
      if (this.photoFile) {
        this.$bus.$emit('loading', false)
        api.uploadCertificate(fileFormData).then(res => {
          if (res.status) {
            if (res.data.code == 200) {
              this.$router.replace({ path: '/home/success' })
            } else if (res.data.code == 1038) {
              this.$bus.$emit('loading', true)
              this.toggleFixed()
              this.isRepeatPop = !this.isRepeatPop
            }
          }
        })
      }
    }
  }
}
</script>
